import { Outlet, createRootRoute } from "@tanstack/react-router"
import { withProfiler } from "@/monitoring"
import { Root } from "@/base"

export const Route = createRootRoute({
  component: withProfiler(() => (
    <Root>
      <Outlet />
    </Root>
  )),
})
